import { Controller } from "@hotwired/stimulus"

// Форма складской операции меняется вместе с типом: подпись склада («На склад» /
// «Со склада» / «Склад»), пояснение под выбором типа и подсказка у количества.
// Поле направления показывается только у корректировки — у прихода и расхода
// направление задаёт сам тип.
//
// Все тексты приходят из локали через data-атрибут hints: русских строк здесь нет,
// иначе перевод формы был бы неполным (находка 62).
export default class extends Controller {
  static targets = ["type", "direction", "explanation", "quantityHint", "warehouseLabel"]
  static values = { hints: Object }

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.typeTarget.value
    const hint = this.hintsValue[type]

    this.directionTarget.hidden = type !== "correction"

    if (!hint) return

    if (this.hasExplanationTarget) this.explanationTarget.textContent = hint.explanation
    if (this.hasQuantityHintTarget) this.quantityHintTarget.textContent = hint.quantity_hint
    if (this.hasWarehouseLabelTarget) this.warehouseLabelTarget.textContent = hint.warehouse
  }
}
